const reviews = [
  {
    name: "Amanda L.",
    location: "Helena, MT",
    rating: 5,
    text: "As a state government employee, I travel internationally for policy conferences. Fast Passport Center always gets my renewals done in under 8 days. They know what Helena residents need and deliver every time.",
    service: "Expedited Renewal",
  },
  {
    name: "Ryan B.",
    location: "East Helena, MT",
    rating: 5,
    text: "Planning a trip through Canada on short notice — needed passport renewal fast. Fast Passport Center delivered in 6 days. For Helena residents, this is the only way to go. Denver just isn't practical.",
    service: "Emergency Renewal",
  },
  {
    name: "Lisa M.",
    location: "Montana City, MT",
    rating: 5,
    text: "First passport for my teenager. The team walked us through every requirement, caught a photo issue before submission, and had the passport delivered before our trip to Ireland. Absolutely recommend.",
    service: "New Passport",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Helena Travelers Are Saying
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Real customers. Real results. No Denver agency trip required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-7 flex flex-col">
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: r.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">&ldquo;{r.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{r.name}</p>
                  <p className="text-gray-400 text-xs">{r.location}</p>
                </div>
                <span className="bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {r.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}